import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@/components/ui/alert-dialog';

type YesNoDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: React.ReactNode;
  onConfirm: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmClassName?: string;
  confirmDisabled?: boolean;
  hideCloseButton?: boolean;
};

export const YesNoDialog: React.FC<YesNoDialogProps> = ({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  confirmLabel = 'Yes',
  cancelLabel = 'No',
  confirmClassName = '',
  confirmDisabled = false,
  hideCloseButton = false
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent hideCloseButton={hideCloseButton} className="bg-white p-3 rounded-md shadow-md max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-sm font-medium">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-xs text-gray-600">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-3 gap-2">
          <AlertDialogAction
            className={`h-7 text-xs font-medium ${confirmClassName}`.trim()}
            onClick={onConfirm}
            disabled={confirmDisabled}
          >
            {confirmLabel}
          </AlertDialogAction>
          <AlertDialogCancel className="h-7 text-xs font-medium">
            {cancelLabel}
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default YesNoDialog;
